/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const LiveIcon = createIcon({
  displayName: "LiveIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M2.5 7.99969C2.5 5.78113 3.8136 3.86781 5.70868 2.99804L5.08299 1.63477C2.67488 2.74 1 5.17347 1 7.99969C1 10.8259 2.67488 13.2594 5.08299 14.3646L5.70868 13.0013C3.8136 12.1316 2.5 10.2182 2.5 7.99969Z"
        fill="currentColor"
      />
      <path
        d="M10.2913 2.99804C12.1864 3.86781 13.5 5.78113 13.5 7.99969C13.5 10.2182 12.1864 12.1316 10.2913 13.0013L10.917 14.3646C13.3251 13.2594 15 10.8259 15 7.99969C15 5.17347 13.3251 2.74001 10.917 1.63477L10.2913 2.99804Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 5.24967C6.48122 5.24967 5.25 6.48088 5.25 7.99967C5.25 9.51845 6.48122 10.7497 8 10.7497C9.51878 10.7497 10.75 9.51845 10.75 7.99967C10.75 6.48088 9.51878 5.24967 8 5.24967ZM6.75 7.99967C6.75 7.30931 7.30964 6.74967 8 6.74967C8.69036 6.74967 9.25 7.30931 9.25 7.99967C9.25 8.69002 8.69036 9.24967 8 9.24967C7.30964 9.24967 6.75 8.69002 6.75 7.99967Z"
        fill="currentColor"
      />
    </g>
  )
});
